export type Coach = {
  name: string
  role: string
  /** Optional photo. When empty, an initials badge is shown. */
  avatar: string
}

/**
 * PLACEHOLDER coaches for the hero row and review cards.
 * Replace names, roles and photos with real buyers before running traffic.
 */
export const coaches: Coach[] = [
  { name: 'Coach name', role: 'Volunteer coach · U10 boys · City, MD', avatar: '' },
  { name: 'Coach name', role: 'Parent coach · U8 girls · City, CT', avatar: '' },
  { name: 'Coach name', role: 'Rec league coach · U12 · City, ON', avatar: '' },
  { name: 'Coach name', role: 'Club coach · U10 · City, CO', avatar: '' },
  { name: 'Coach name', role: 'Club coach · U12 girls · City, UK', avatar: '' },
  { name: 'Coach name', role: 'School coach · U14 · City, NSW', avatar: '' },
]

/** Badge colors for the initials avatars (product palette). */
export const avatarColors = ['bg-turf', 'bg-sky', 'bg-gold', 'bg-navy-line', 'bg-turf', 'bg-sky']
